import React, { useState } from "react";
import { createPortal } from "react-dom";
import styles from "./PreviewModal.module.scss";
import "../styles.scss";

interface PreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

type ViewportMode = 'desktop' | 'mobile';

const PreviewModal: React.FC<PreviewModalProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  const [viewportMode, setViewportMode] = useState<ViewportMode>('desktop');

  if (!isOpen) {
    return null;
  }

  const toggleViewport = (mode: ViewportMode) => {
    setViewportMode(mode);
  };

  return createPortal(
    <div className={styles.modal_overlay} onClick={onClose}>
      <div
        className={`${styles.modal_container} ${viewportMode === 'mobile' ? styles.mobile_viewport : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.modal_header}>
          <div className={styles.preview_banner}>
            <span className={styles.preview_icon}>👁️</span>
            <span>Preview Mode - Changes are not saved yet</span>
          </div>
          <div className={styles.viewport_controls}>
            <button
              className={`${styles.viewport_button} ${viewportMode === 'desktop' ? styles.active : ''}`}
              onClick={() => toggleViewport('desktop')}
              title="Desktop view"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M8 21H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M12 17V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <button
              className={`${styles.viewport_button} ${viewportMode === 'mobile' ? styles.active : ''}`}
              onClick={() => toggleViewport('mobile')}
              title="Mobile view"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="2" width="14" height="20" rx="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 18H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
          {/* Close button - desktop: top right inside modal, mobile: in header */}
          <button className={styles.close_button} onClick={onClose} title="Close">
            <span className={styles.close_text}>Close</span>
            <svg className={styles.close_icon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        <div className={`${styles.modal_content} public-profiles-wrapper ${viewportMode === 'mobile' ? styles.mobile_content : ''}`}>
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PreviewModal;
